// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * The abandoned-upload grace window (hours): the default, and the bounds the server
 * accepts. One declaration read by the settings service, its route and the Files
 * Configuration page, so the form's bounds and the server's cannot drift.
 *
 * The floor is one session (`SESSION_LIFETIME_HOURS = 24`, asserted by
 * `abandoned-grace-window.test.ts`): a row still inside the window can belong to a
 * live form, so a shorter window would let the sweep clear a file somebody is still
 * attaching. The default is 72 hours - an operator part-filling a declaration across a
 * weekend - and the ceiling a year.
 */
export const DEFAULT_ABANDONED_UPLOAD_GRACE_HOURS = 72;
export const MIN_ABANDONED_UPLOAD_GRACE_HOURS = 24;
export const MAX_ABANDONED_UPLOAD_GRACE_HOURS = 24 * 365;
//# sourceMappingURL=platform-file-settings.js.map